.container {
  display: flex;
  flex-direction: column;
  gap: var(--dds-spacing-x0-125);
}

.group {
  display: flex;
}

.group--row {
  flex-direction: row;
  gap: var(--dds-spacing-x0-75);
}

.group--column {
  flex-direction: column;
  gap: var(--dds-spacing-x0-75);
}

.label {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;

  &:not(:hover)
    input[aria-invalid]:enabled:not([aria-readonly='true']):not(
      :focus-visible
    ):not(:checked)
    ~ .selection-control {
    background-color: var(--dds-color-surface-danger-default);
  }
}

.label:has(input:enabled) {
  input[aria-invalid]:not([aria-readonly='true']):not(:focus-visible)
    ~ .selection-control {
    border-color: var(--dds-color-border-danger);
    box-shadow: inset 0 0 0 1px var(--dds-color-border-danger);
  }

  &:hover input:not(:checked):not([aria-readonly='true']) ~ .selection-control {
    background-color: var(--dds-color-surface-hover-default);
    box-shadow: inset 0 0 0 1px var(--dds-color-border-action-hover);
    border-color: var(--dds-color-border-action-hover);
  }

  input:checked ~ .selection-control,
  input[data-indeterminate='true'] ~ .selection-control {
    border-color: var(--dds-color-surface-action-selected);
    background-color: var(--dds-color-surface-action-selected);
  }

  input:checked[aria-readonly='true'] ~ .selection-control,
  input[data-indeterminate='true'][aria-readonly='true'] ~ .selection-control {
    border-color: var(--dds-color-surface-action-selected-disabled);
    background-color: var(--dds-color-surface-action-selected-disabled);
  }

  &:hover {
    input:enabled:not([aria-readonly='true']) {
      &:checked[type='checkbox'],
      &[data-indeterminate='true'] {
        ~ .selection-control {
          background-color: var(--dds-color-surface-action-hover);
          border-color: var(--dds-color-surface-action-hover);
        }
      }
    }
  }
}

input:checked ~ .selection-control:after,
input[data-indeterminate='true'] ~ .selection-control:after {
  display: block;
}

.label--checkbox {
  .selection-control:after {
    border: solid var(--dds-color-icon-on-action);
    border-width: 0 1px 1px 0;
    left: 35%;
    top: 10%;
    width: 30%;
    height: 60%;
    transform: rotate(45deg);
  }

  input[data-indeterminate='true'] ~ .selection-control:after {
    border-width: 1px 0 0 0;
    left: 25%;
    top: 50%;
    width: 50%;
    height: 1px;
    transform: none;
  }
}

.label--radio {
  .selection-control:after {
    border-radius: var(--dds-border-radius-rounded);
    background-color: var(--dds-color-icon-on-action);
    height: 45%;
    width: 45%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.label:has(input:disabled) {
  cursor: not-allowed;
  input ~ .selection-control {
    border-color: var(--dds-color-border-subtle);
  }
  input:checked ~ .selection-control,
  input[data-indeterminate='true'] ~ .selection-control {
    border-color: var(--dds-color-surface-action-selected-disabled);
    background-color: var(--dds-color-surface-action-selected-disabled);
  }

  .label:has(input[aria-readonly='true']) {
    cursor: default;
    color: var(--dds-color-text-medium);
    input ~ .selection-control {
      border-color: var(--dds-color-border-default);
      background-color: var(--dds-color-surface-field-disabled);
    }
    input:checked ~ .selection-control,
    input[data-indeterminate='true'] ~ .selection-control {
      border-color: var(--dds-color-surface-action-selected-disabled);
      background-color: var(--dds-color-surface-action-selected-disabled);
    }
  }
}

.label--no-text {
  padding: 9px;
}

.selection-control {
  position: absolute;
  left: 0;
  box-sizing: border-box;
  border: 1px solid;
  border-color: var(--dds-color-border-default);
  background-color: var(--dds-color-surface-field-default);
  border-radius: var(--dds-border-radius-input);
  height: var(--dds-size-icon-component);
  width: var(--dds-size-icon-component);
  &:after {
    content: '';
    position: absolute;
    display: none;
    box-sizing: border-box;
  }
  @media (prefers-reduced-motion: no-preference) {
    transition:
      box-shadow var(--dds-motion-micro-state),
      background-color var(--dds-motion-micro-state),
      border var(--dds-motion-micro-state),
      border-color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }
}

.selection-control--radio {
  border-radius: var(--dds-border-radius-rounded);
}
